import {gunlukZamanlayiciOlustur} from "@/plugins/uyap-plugin/GunlukZamanlayici";

/**
 * Sabah raporu bildirimi zamanlayıcısı (Sorgu Snapshot Faz 3, DEV-2968).
 *
 * Ön-kontrol zamanlayıcısıyla AYNI motoru kullanır ama AYRI bir modüldür ve
 * AYRI bir depolama anahtarı taşır: ikisi aynı anahtarı paylaşsaydı sabahki
 * ateşleme akşamki ön-kontrolü (ya da tersi) susturur, aynı gün ikinci iş hiç
 * koşmazdı.
 *
 * F3-D5: rapor ÇEKME modelidir. Sunucudan push yok; uygulama açıksa ayarlanan
 * saatte bir kez `GET /v1/senkron-rapor` çekilir.
 */

const DEPOLAMA_ANAHTARI = "senkronSabahRaporuSonAtesGunu";

let kanca: (() => void | Promise<void>) | null = null;

export function sabahRaporuKancasiniAyarla(fn: (() => void | Promise<void>) | null): void {
    kanca = fn;
}

const zamanlayici = gunlukZamanlayiciOlustur({
    depolamaAnahtari: DEPOLAMA_ANAHTARI,
    ateslendiginde: () => {
        if (!kanca) return;
        return kanca();
    }
});

export const SenkronSabahRaporuZamanlayici = zamanlayici;
